// extracted by extract-css-chunks-webpack-plugin
module.exports = {"spinner":"_3GL8NE","small":"_3gNniv","lds-default":"_3X6sip"};